// app/javascript/controllers/invoice_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["purchasedAt", "invoiceNumber", "invoiceAttachment", "attachmentFileName"]

  connect() {
    this.updateFields()
    this.purchasedAtTarget.addEventListener("change", () => this.updateFields())

    if (this.hasAttachmentFileNameTarget) {
      this.invoiceAttachmentTarget.addEventListener("change", () => {
        const file = this.invoiceAttachmentTarget.files[0]
        if (file) this.attachmentFileNameTarget.textContent = file.name
      })
    }
  }

  updateFields() {
    const value = this.purchasedAtTarget.value
    if (value === "rsct") {
      this.show(this.invoiceNumberTarget)
      this.hide(this.invoiceAttachmentTarget)
    } else if (value === "anderer") {
      this.hide(this.invoiceNumberTarget)
      this.show(this.invoiceAttachmentTarget)
    } else {
      this.hide(this.invoiceNumberTarget)
      this.hide(this.invoiceAttachmentTarget)
    }
  }

  show(el) {
    el.style.display = "block"

    const input = el.querySelector("input.set-required")
    if (input) {
      input.disabled = false
      input.required = true
    }

    const label = el.querySelector("label.set-required")
    if (label) {
      label.classList.add("required")
    }
  }

  hide(el) {
    el.style.display = "none"

    const input = el.querySelector("input.set-required")
    if (input) {
      input.disabled = true
      input.required = false
    }

    const label = el.querySelector("label.set-required")
    if (label) {
      label.classList.remove("required")
    }
  }
}
